import React, { Component } from 'react'
import { Header, ActionCard, PageWrapper } from '../components'

class FAQs extends Component {
  state = {}
  render() {
    const native = this.props.location.pathname.indexOf('native') > -1
    return (
      <React.Fragment>
        {!native && (
          <Header
            title={'Frequently Asked Questions'}
            icon="arrowBack"
            onClickBack={() => this.props.history.replace('/user-profile')}
            color="#fff"
          />
        )}
        <PageWrapper viewPadding={native ? '5.4% 3.9% 6%' : '22.4% 3.9% 6%'} height="100%">
          <ActionCard
            label="I already don’t trust most food brands and labels, why should I trust GreenChoice?"
            onTouch={() =>
              this.props.history.push(native ? '/faq/why-trust-greenchoice/native' : '/faq/why-trust-greenchoice')
            }
            margin="0 0 10px 0"
          />
          <ActionCard
            label="How does GreenChoice make money?"
            onTouch={() => this.props.history.push(native ? '/faq/make-money/native' : '/faq/make-money')}
            margin="0 0 10px 0"
          />
          <ActionCard
            label="What does the PBC mean? I usually see LLC or Corp. after a company name."
            onTouch={() => this.props.history.push(native ? '/faq/pbc-mean/native' : '/faq/pbc-mean')}
            margin="0 0 10px 0"
          />
          <ActionCard
            label="Does GreenChoice, PBC have a conflict of interest policy?"
            onTouch={() =>
              this.props.history.push(native ? '/faq/pbc-interest-policy/native' : '/faq/pbc-interest-policy')
            }
            margin="0 0 10px 0"
          />
          <ActionCard
            label="What values guide the GreenChoice team?"
            onTouch={() => this.props.history.push(native ? '/faq/values-guide/native' : '/faq/values-guide')}
            margin="0 0 10px 0"
          />
        </PageWrapper>
      </React.Fragment>
    )
  }
}

export default FAQs



// WEBPACK FOOTER //
// ./src/pages/FAQs.js